import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconSend = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M3.5 4.5 21 12 3.5 19.5 6 12z' />
      <path d='M6 12h7' />
    </g>
  </SDIcon>
)

export default IconSend
